__turbopack_context__.v({
  "edgeStack": "styles-module__jdEKoq__edgeStack",
});
